import classNames from 'clsx';
import React, { FC, memo, ReactNode } from 'react';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from '../DataListItemRow.css';

interface DestinationProps {
    name: string;
    icon?: ReactNode;
    noOverflow?: boolean;
}

export const Destination: FC<DestinationProps> = memo(function Destination({ name, icon, noOverflow }) {
    return (
        <div className={classNames(styles.destination, { [styles.destinationNoOverflow]: noOverflow })}>
            {icon && <div className={styles.destinationIcon}>{icon}</div>}
            <NameComponent name={name} showTooltip />
        </div>
    );
});
